import Leanplum from 'leanplum-sdk';
import { CurrentUser } from '../user/currentUser';
import { PushJsonRpcRequest } from "./PushJsonRpcRequest";
import { NotificationsRpcMethods } from "./constants/NotificationsRpcMethods";
import { GetAccountStateError } from "./Errors/GetAccountStateError";
import { GetSubscriptionStateError } from "./Errors/GetSubscriptionStateError";
import { GetActiveStateError } from "./Errors/GetActiveStateError";
import { SetAccountStateError } from "./Errors/SetAccountStateError";
import { SaveNewUserOnNotificationsError } from "./Errors/SaveNewUserOnNotificationsError";
import {
    IAddNewAccountRequest,
    IAddNewAccountResponse, ICheckAccountResponse,
    ICheckAccountRequest,
    ISetAccountStatRequest
} from "./INotificationService";
import { UserSession } from "../user/userSession";
import { PushForbiddenError } from "./Errors/PushForbiddenError";



export class WebpushServiceApi {
    static async saveUserToken(token: string) {
        try {
            const currentUser = CurrentUser.getInstance();
            const requestData: IAddNewAccountRequest = {
                platform: window.app.config.user_browser.name,
                signature: currentUser.getAuthToken(),
                suid: currentUser.getSuid(),
                token: token
            };
            const response = await PushJsonRpcRequest.makeRequest<
                IAddNewAccountResponse, IAddNewAccountRequest>(
                    NotificationsRpcMethods.UPDATE,
                    requestData,
                    (UserSession.getInstance()).getDeviceId()
            );

            if ('error' in response) {
                throw new SaveNewUserOnNotificationsError(response.error.message);
            }

            if (response.isAccountAdded) {
                console.log('[Notification Service] New account is success added', response);
                return;
            }

            throw new SaveNewUserOnNotificationsError('[Notification Service] New account is not added');
        } catch (exception) {
            throw new SaveNewUserOnNotificationsError(exception.message, exception.stack);
        }
    }

    static async setAccountState(state: boolean): Promise<{isUpdated: boolean}> {
        try {
            const currentUser = CurrentUser.getInstance();
            const requestData: ISetAccountStatRequest = {
                platform: window.app.config.user_browser.name,
                signature: currentUser.getAuthToken(),
                suid: currentUser.getSuid(),
                state: state
            };
            const response = await PushJsonRpcRequest.makeRequest<
                {isUpdated: boolean}, ISetAccountStatRequest>(
                    NotificationsRpcMethods.STATE,
                    requestData,
                    (UserSession.getInstance()).getDeviceId()
            );

            if ('error' in response) {
                throw new SetAccountStateError(response.error.message);
            }

            return response;
        } catch (exception) {
            throw new SetAccountStateError(exception.message, exception.stack);
        }
    }

    static async isActiveAccount(): Promise<boolean> {
        try {
            const state = await this.getAccountState();
            return state.accountAlreadyExist;
        } catch (exception) {
            throw new GetActiveStateError(exception.message, exception.stack)
        }
    }

    static async getPushSubscriptionState(): Promise<boolean | string> {
        try {
            const state = await this.getAccountState();

            return state.lastUpdatedDate;
        } catch (exception) {
            throw new GetSubscriptionStateError(exception.message, exception.stack)
        }
    }

    static checkNotificationsInBrowserGranted(): boolean {
        return Leanplum.isWebPushSupported();
    }

    private static async getAccountState(): Promise<ICheckAccountResponse> {
        try {
            console.log('[Notification Service] try to send request on check account');
            const currentUser = CurrentUser.getInstance();
            const response = await PushJsonRpcRequest.makeRequest<
                ICheckAccountResponse, ICheckAccountRequest>(
                NotificationsRpcMethods.CHECK,
                {
                    platform: window.app.config.user_browser.name,
                    suid: currentUser.getSuid(),
                    signature: currentUser.getAuthToken()
                },
                (UserSession.getInstance()).getDeviceId()
            );

            if ('error' in response) {
                if (response.error.code === 403) {
                    throw new PushForbiddenError(response.error.message);
                }

                throw new GetAccountStateError(response.error.message);
            }

            if ('lastUpdatedDate' in response) {
                return response;
            }

            throw new GetAccountStateError('[Notification Service] Failed on get an account state');
        } catch (exception) {
            throw new GetAccountStateError(exception.message, exception.stack)
        }
    }
}
